/* The staff app's 4-digit PIN. The same rule runs on the phone and on the server. */

export const PIN_LENGTH = 4;

export const isPinShaped = (pin: string) => /^\d{4}$/.test(pin);

/**
 * Too easy to guess: one digit four times (1111), a run up or down (1234,
 * 9876), or two pairs (1212, 1122).
 */
export function isWeakPin(pin: string): boolean {
  if (!isPinShaped(pin)) return true;
  const d = [...pin].map(Number);
  const step = d[1] - d[0];
  if ((step === 0 || step === 1 || step === -1) && d.every((x, i) => i === 0 || x - d[i - 1] === step)) return true;
  if (d[0] === d[2] && d[1] === d[3]) return true;
  if (d[0] === d[1] && d[2] === d[3]) return true;
  return false;
}

